<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-toolbar dense  dark color="primary">
          <v-toolbar-title>{{$t("view.seguimientoControl.title")}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          
          <v-list dense three-line subheader>
            <v-subheader>{{$t("view.comercio.detalle")}}</v-subheader>
            <v-divider></v-divider>
              <v-list-tile v-if="!!detalleBitacora">
                <v-list-tile-content :key="index" avatar v-for="(detalle, index) of detalleBitacora.split(',')">
                  <v-list-tile-title>{{detalle.split('=')[0]}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{detalle.split('=')[1]}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green darken-1" flat @click.native="dialog = false">Disagree</v-btn>
          <v-btn color="green darken-1" flat @click.native="dialog = false">Agree</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      dialog : false
      , detalleBitacora : null
    }
  }
  ,methods: {
    openDialog(detalle){
      this.dialog = true;
      this.detalleBitacora = detalle;
    }
  }
  , mounted(){
    const vm = this;
    function emitEventOpenDoalog(event){
      const {dialog} = this;
      vm.dialog = dialog;
      vm.$emit('openDialog',dialog);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/seguimiento/scheduled/ModalDetalleSeguimiento.vue